import { TitleCasePipe } from '@angular/common';
import {
  Component,
  ViewContainerRef,
  inject,
  input,
  output,
} from '@angular/core';
import {
  OnboardingStepNumber,
  StepGuideId,
  TeamMemberService,
} from '@maximizer/outlook/shared/data-access';
import { EntryType, OutlookEmail } from '@maximizer/outlook/shared/domain';
import {
  MenuItem,
  OUTLOOK_SHARED_UI,
} from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import {
  KENDO_LISTVIEW,
  PagerSettings,
} from '@progress/kendo-angular-listview';
import { KENDO_TOOLTIPS } from '@progress/kendo-angular-tooltip';

export interface AddEntryEvent {
  event: { route: string };
  email: string;
  name: string;
}

@Component({
  selector: 'maximizer-outlook-not-in-maximizer-list',
  templateUrl: './not-in-maximizer-list.component.html',
  imports: [
    KENDO_BUTTONS,
    KENDO_LISTVIEW,
    KENDO_TOOLTIPS,
    OUTLOOK_SHARED_UI,
    TitleCasePipe,
    TranslatePipe,
  ],
})
export class OutlookNotInMaximizerListComponent {
  private readonly teamMemberService = inject(TeamMemberService);
  readonly viewContainerRef = inject(ViewContainerRef);

  entries = input<OutlookEmail[]>([]);
  pagerSettings = input<PagerSettings | boolean>(false);
  pageSize = input<number>(4);
  loading = input<boolean>(true);
  addEntryMenuItems = input<MenuItem[]>([]);

  onboardingInProgress = input<boolean>(false);
  currentGuide = input<StepGuideId | undefined>(undefined);
  currentStep = input<OnboardingStepNumber | undefined>(undefined);
  inMaximizerLength = input<number>(0);

  addEntry = output<AddEntryEvent>();
  addEntryDropDownOpen = output<void>();
  addEntryDropDownClose = output<void>();

  readonly EntryType = EntryType;
  readonly StepGuideId = StepGuideId;
  readonly OnboardingStepNumber = OnboardingStepNumber;

  isTeamMember(email: string): boolean {
    return this.teamMemberService.isTeamMember(email);
  }

  onItemClick(event: { route: string }, email: OutlookEmail): void {
    this.addEntry.emit({
      event,
      email: email.emailAddress,
      name: email.displayName,
    });
  }
}
